function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
import { MERCHANT_WPF_THEMES_INITIAL_UPDATE, MERCHANT_WPF_THEMES_UPDATE_FAIL, MERCHANT_WPF_THEMES_UPDATE_REQUEST, MERCHANT_WPF_THEMES_UPDATE_SUCCESS } from '@engine/actions/action-types';
/**
 * Initial state
 */

var INITIAL_STATE = {
  hasError: false,
  isUpdating: false,
  theme: null
};
/**
 * Reducer
 */

function merchantWpfThemesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case MERCHANT_WPF_THEMES_INITIAL_UPDATE:
      return _objectSpread(_objectSpread({}, state), {}, {
        theme: action.data.theme
      });

    case MERCHANT_WPF_THEMES_UPDATE_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        hasError: false,
        isUpdating: true
      });

    case MERCHANT_WPF_THEMES_UPDATE_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        hasError: action.data.error,
        isUpdating: false,
        theme: action.data.theme
      });

    case MERCHANT_WPF_THEMES_UPDATE_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        hasError: true,
        isUpdating: false
      });

    default:
      return state;
  }
}

export default merchantWpfThemesReducer;